
import { Component, Prop, Vue } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import QuestionText from "./QuestionText.vue";
import AdminOptions from "./AdminOptions.vue";
import { SurveyQuestion } from "@/model/SurveyQuestion";
import { SurveyQuestionOptions } from "@/model/SurveyQuestionOptions";
import utils from "@/stuff/Utils";
import { ResponseStatus } from "@/model/Enums";

@Component({ components: { QuestionText, AdminOptions } })
export default class Integer extends Vue {

    @Prop({ required: true })
    private question!: SurveyQuestion;

    @Prop({ default: SurveyQuestionOptions.CreateDefault })
    private options!: SurveyQuestionOptions;

    errorMessage = "";

    private get tooltipTargetID(): string {
        return "tooltipTarget-" + this.question.id;
    }

    private get isReadOnly(): boolean {
        return this.options.isReadOnly || this.question.supplierResponses.status == ResponseStatus.Accepted
    }

    private get numberText(): string {
        return String(this.question.supplierResponses.numberResponse);
    }
    private set numberText(value: string) {
        this.question.supplierResponses.numberResponse = utils.hasNumericValue(value) ? Math.floor(+value) : null;
    }

    @Validations()
    validations() {
        return {
            responseText: { 
                isValid: () => true
            }
        };
    }
}
